import type { SeriesCard as SeriesCardType, Sponsor } from '@/shared/api-generated-types'
import React, { ReactElement } from 'react'
import Standard from './render/Standard'

type PossibleString = string | null | undefined

export interface Props {
  numberOfClasses?: number
  footerContent?: React.ReactNode | null
  href?: PossibleString
  id?: PossibleString
  imageUrl?: PossibleString
  title?: PossibleString
  navigationAction?: SeriesCardType['navigationAction']
  fluid?: boolean
  wide?: boolean
  fixedAspectRatio?: boolean
  sponsor?: Sponsor
}

export interface VariantProps extends Props {
  handleAction: (event: React.MouseEvent) => void
}

export const CardNavigationAction = React.memo(function CardNavigationAction({
  navigationAction,
  children,
}: {
  navigationAction?: SeriesCardType['navigationAction']
  children: ReactElement
}): ReactElement {
  const action = navigationAction ? navigationAction.__typename : undefined

  if (action === 'NavigateToSeriesAction') {
    return React.cloneElement(children, {
      component: 'link',
      href: navigationAction?.url,
    })
  }

  return children
})

const SeriesCard = ({ ...props }: Props): ReactElement => {
  const variantProps = { ...props }
  return <Standard {...variantProps} />
}
export default SeriesCard
